"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createReducers = void 0;
var _connectedReactRouter = require("connected-react-router");
var _geo = require("@otpusk/apisearch-toolbox/dist/geo");
var _queries = require("@otpusk/apisearch-toolbox/dist/queries");
var _search = require("@otpusk/apisearch-toolbox/dist/search");
var _hotels = require("@otpusk/apisearch-toolbox/dist/hotels");
var _offers = require("@otpusk/apisearch-toolbox/dist/offers");
var _services = require("@otpusk/apisearch-toolbox/dist/services");
var _reducer = _interopRequireDefault(require("@otpusk/apisearch-toolbox/dist/reviews/reducer"));
var _reducer2 = _interopRequireDefault(require("@otpusk/apisearch-toolbox/dist/static/reducer"));
var _reducer3 = require("../bus/auth/reducer");
var _reducer4 = require("../bus/ui/reducer");
var _reducer5 = _interopRequireDefault(require("../bus/stats/reducer"));
var _external = require("../bus/external");
var _reducer6 = _interopRequireDefault(require("../modalDispatcher/store/reducer"));
var _reducer7 = _interopRequireDefault(require("../components/collections/store/reducer"));
var _reducer8 = _interopRequireDefault(require("../components/Search/components/GeoTreeControl/store/reducer"));
var _reducer9 = _interopRequireDefault(require("../components/Search/store/reducer"));
var _reducer10 = _interopRequireDefault(require("../components/Results/components/PriceAnalytics/store/reducer"));
var _reducer11 = _interopRequireDefault(require("../components/Results/store/reducer"));
var _reducer12 = _interopRequireDefault(require("../components/modals/SaveToClaim/store/reducer"));
var _reducer13 = _interopRequireDefault(require("../components/Results/components/OfferDetails/store/reducer"));
var _reducer14 = _interopRequireDefault(require("../components/Baskets/store/reducer"));
var _reducer15 = _interopRequireDefault(require("../components/Baskets/components/Results/components/EditForm/components/SendBasketModal/store/reducer"));
var _SaveOfferToBasketModal = require("../components/modals/SaveOfferToBasketModal");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var createReducers = exports.createReducers = function createReducers(browserHistory) {
  return {
    geo: _geo.geoReducer,
    queries: _queries.queriesReducer,
    search: _search.searchReducer,
    auth: _reducer3.authReducer,
    hotels: _hotels.hotelsReducer,
    offers: _offers.offersReducer,
    services: _services.servicesReducer,
    router: (0, _connectedReactRouter.connectRouter)(browserHistory),
    ui: _reducer4.uiReducer,
    modalDispatcher: _reducer6.default,
    collections: _reducer7.default,
    geoTree: _reducer8.default,
    searchPricesForm: _reducer9.default,
    priceAnalytics: _reducer10.default,
    reviews: _reducer.default,
    stats: _reducer5.default,
    staticData: _reducer2.default,
    searchResults: _reducer11.default,
    saveToClaimModal: _reducer12.default,
    offerDetails: _reducer13.default,
    rootBaskets: _reducer14.default,
    sendBasketModal: _reducer15.default,
    saveOfferToBasketModal: _SaveOfferToBasketModal.saveOfferToBasketModalReducer,
    external: _external.externalReducer
  };
};